const DEFAULT_DATA_SOURCE_ID = 'default';

/**
 * Builds a localStorage key scoped to a user and data source.
 */
const scopedStorageKey = (
  prefix: string,
  { userId, appDataSourceId }: { userId?: string | number | null; appDataSourceId?: string | number | null }
) => `${prefix}:${String(userId ?? 'anonymous')}:${appDataSourceId || DEFAULT_DATA_SOURCE_ID}`;

export default scopedStorageKey;
